"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _utils = require('shared/store/utils');
var _helpers = require('shared/actions/helpers');

































var _uuid = require('shared/services/uuid');

const findUsersInOrgActions = _utils.createAsyncActions('FindUsersInOrg')
const findTeamsInOrgActions = _utils.createAsyncActions('FindTeamsInOrg')
const findPatientsInOrgActions = _utils.createAsyncActions('FindPatientsInOrg')
const findUsersInTeamActions = _utils.createAsyncActions('FindUsersInTeam')
const findUsersNotInTeamActions = _utils.createAsyncActions('FindUsersNotInTeam')
const updateTeamActions = _utils.createAsyncActions('UpdateTeam')
const getTeamReplySettingsActions = _utils.createAsyncActions('GetTeamReplySettings')
const getPhoneNumberBlocksActions = _utils.createAsyncActions('GetPhoneNumberBlocks')
const addPhoneNumberBlockActions = _utils.createAsyncActions('AddPhoneNumberBlock')
const removePhoneNumberBlockActions = _utils.createAsyncActions('RemovePhoneNumberBlock')
const getPhoneNumberBlockedMessagesActions = _utils.createAsyncActions('GetPhoneNumberBlockedMessages')
const getUsersActions = _utils.createAsyncActions('GetUsers_V5')
const getTeamsActions = _utils.createAsyncActions('GetTeams')
const getPatientActions = _utils.createAsyncActions('GetPatient')
const getOrgsActions = _utils.createAsyncActions('GetOrgs')
const directoryLookupActions = _utils.createAsyncActions('DirectoryLookupV2')
const createTeamActions = _utils.createAsyncActions('CreateTeam')
const removeTeamActions = _utils.createAsyncActions('RemoveTeam')
const addUsersToTeamActions = _utils.createAsyncActions('AddUsersToTeam')
const removeUserFromTeamActions = _utils.createAsyncActions('RemoveUserFromTeam')
const createPatientActions = _utils.createAsyncActions('NewPatient')
const updatePatientActions = _utils.createAsyncActions('UpdatePatientInfo')
const resubscribePatientSMSActions = _utils.createAsyncActions('ResubscribePatientSMS')
const markPatientSMSOptedOutActions = _utils.createAsyncActions('MarkPatientSMSOptedOut')
const blockPatientSMSActions = _utils.createAsyncActions('BlockPatientSMS')
const unblockPatientSMSActions = _utils.createAsyncActions('UnblockPatientSMS')
const clearPatientSMSUnreachableActions =
  _utils.createAsyncActions('ClearPatientSMSUnreachable')
const getPatientsSharingSMSPhoneActions =
  _utils.createAsyncActions('GetPatientsSharingSMSPhone')
const inviteUserToMyOrgActions = _utils.createAsyncActions('InviteUserToMyOrg')
const inviteUserNoOrgActions = _utils.createAsyncActions('InviteUserNoOrg')

 const actionCreators = {
  updateTeamActions,
  getTeamReplySettingsActions,
  findUsersInOrgActions,
  findTeamsInOrgActions,
  findPatientsInOrgActions,
  findUsersInTeamActions,
  findUsersNotInTeamActions,
  getPhoneNumberBlocksActions,
  addPhoneNumberBlockActions,
  removePhoneNumberBlockActions,
  getPhoneNumberBlockedMessagesActions,
  getTeamsActions,
  getUsersActions,
  getPatientActions,
  getOrgsActions,
  directoryLookupActions,
  createTeamActions,
  removeTeamActions,
  addUsersToTeamActions,
  removeUserFromTeamActions,
  createPatientActions,
  updatePatientActions,
  resubscribePatientSMSActions,
  markPatientSMSOptedOutActions,
  blockPatientSMSActions,
  unblockPatientSMSActions,
  clearPatientSMSUnreachableActions,
  getPatientsSharingSMSPhoneActions,
  inviteUserToMyOrgActions,
  inviteUserNoOrgActions,
}; exports.actionCreators = actionCreators

const findUsersInOrg = (req) =>
  req.OrgKey && req.OrgKey !== _uuid.EMPTY_BLUID
    ? _helpers.wsCommand('FindUsersInOrg', findUsersInOrgActions, req, null)
    : Promise.resolve({ Users: [] })

const findTeamsInOrg = (req) =>
  req.OrgKey && req.OrgKey !== _uuid.EMPTY_BLUID
    ? _helpers.wsCommand('FindTeamsInOrg', findTeamsInOrgActions, req, null)
    : Promise.resolve({ Teams: [] })

const findPatientsInOrg = (req) =>
  req.OrgKey && req.OrgKey !== _uuid.EMPTY_BLUID
    ? _helpers.wsCommand('FindPatientsInOrg', findPatientsInOrgActions, req, null)
    : Promise.resolve({ Patients: [] })

const findUsersInTeam = (req) =>
  _helpers.wsCommand('FindUsersInTeam', findUsersInTeamActions, req, null)

const findUsersNotInTeam = (req) =>
  _helpers.wsCommand('FindUsersNotInTeam', findUsersNotInTeamActions, req, null)

const getUsers = async (req) =>
  req.UserKeys.length
    ? _helpers.wsCommand('GetUsers_V5', getUsersActions, req, null)
    : { Orgs: {}, Users: {} }

const getTeams = async (req) =>
  req.TeamKeys.length
    ? _helpers.wsCommand('GetTeams', getTeamsActions, req, null)
    : { Teams: {} }

const getPatient = (req) =>
  _helpers.wsCommand('GetPatient_V2', getPatientActions, req, null)

const getOrgs = async (req) =>
  req.OrgKeys.length
    ? _helpers.wsCommand('GetOrgs', getOrgsActions, req, null)
    : { Orgs: {} }

const directoryLookup = (req) =>
  _helpers.wsCommand('DirectoryLookupV2', directoryLookupActions, req, null)

const createTeam = (req) =>
  _helpers.wsCommand('CreateTeamAtOrg', createTeamActions, req, null)

const updateTeam = (req) =>
  _helpers.wsCommand('UpdateTeam', updateTeamActions, req, null)

const getTeamReplySettings = (req) =>
  _helpers.wsCommand('GetTeamReplySettings', getTeamReplySettingsActions, req, null)

const getPhoneNumberBlocks = (req) =>
  _helpers.wsCommand('GetPhoneNumberBlocks', getPhoneNumberBlocksActions, req, null)

const addPhoneNumberBlock = (req) =>
  _helpers.wsCommand('AddPhoneNumberBlock', addPhoneNumberBlockActions, req, null)

const removePhoneNumberBlock = (req) =>
  _helpers.wsCommand('RemovePhoneNumberBlock', removePhoneNumberBlockActions, req, null)

const getPhoneNumberBlockedMessages = (req) =>
  _helpers.wsCommand(
    'GetPhoneNumberBlockedMessages',
    getPhoneNumberBlockedMessagesActions,
    req,
    null,
  )

const removeTeam = (payload) =>
  _helpers.wsCommand('RemoveTeam', removeTeamActions, payload, payload)

const addUsersToTeam = (req) =>
  _helpers.wsCommand('AddUsersToTeam', addUsersToTeamActions, req, null)

const removeUserFromTeam = (req) =>
  _helpers.wsCommand('RemoveUserFromTeam', removeUserFromTeamActions, req, null)

// The backend's `NewPatientArgs.DateOfBirth` / patient DOB is a Go `civil.Date`
// (value type). It unmarshals via `time.Parse("2006-01-02", …)`, which rejects
// an empty string before validation ever runs — the command fails with "Invalid
// Command Data". A phone-only patient with no DOB must therefore OMIT the key on
// the wire rather than send `''`. Strip a blank/whitespace-only DateOfBirth here
// so every caller (guided self-SMS, manual invite, directory create/edit) is
// hardened; a non-empty value passes through byte-for-byte unchanged.
const omitBlankDateOfBirth = (req) => {
  if (req.DateOfBirth && req.DateOfBirth.trim() !== '') return req
  const shaped = { ...req }
  delete (shaped ).DateOfBirth
  return shaped
}

const createPatient = (req) =>
  _helpers.wsCommand('NewPatient', createPatientActions, omitBlankDateOfBirth(req), null)

const updatePatient = (req) =>
  _helpers.wsCommand('UpdatePatientInfo', updatePatientActions, omitBlankDateOfBirth(req), null)

const resubscribePatientSMS = (req) =>
  _helpers.wsCommand('ResubscribePatientSMS', resubscribePatientSMSActions, req, null)

const markPatientSMSOptedOut = (req) =>
  _helpers.wsCommand('MarkPatientSMSOptedOut', markPatientSMSOptedOutActions, req, null)

const blockPatientSMS = (req) =>
  _helpers.wsCommand('BlockPatientSMS', blockPatientSMSActions, req, null)

const unblockPatientSMS = (req) =>
  _helpers.wsCommand('UnblockPatientSMS', unblockPatientSMSActions, req, null)

const clearPatientSMSUnreachable = (req) =>
  _helpers.wsCommand('ClearPatientSMSUnreachable', clearPatientSMSUnreachableActions, req, null)

const getPatientsSharingSMSPhone = (req) =>
  _helpers.wsCommand('GetPatientsSharingSMSPhone', getPatientsSharingSMSPhoneActions, req, null)

const inviteUserToMyOrg = (req) =>
  _helpers.wsCommand('InviteUserToMyOrg', inviteUserToMyOrgActions, req, null)

const inviteUserNoOrg = (req) =>
  _helpers.wsCommand('InviteUserNoOrg', inviteUserNoOrgActions, req, null)

exports. default = {
  findUsersInOrg,
  findTeamsInOrg,
  findPatientsInOrg,
  findUsersInTeam,
  findUsersNotInTeam,
  getUsers,
  getTeams,
  getPatient,
  getOrgs,
  directoryLookup,
  createTeam,
  updateTeam,
  getTeamReplySettings,
  getPhoneNumberBlocks,
  addPhoneNumberBlock,
  removePhoneNumberBlock,
  getPhoneNumberBlockedMessages,
  removeTeam,
  addUsersToTeam,
  removeUserFromTeam,
  createPatient,
  updatePatient,
  resubscribePatientSMS,
  markPatientSMSOptedOut,
  blockPatientSMS,
  unblockPatientSMS,
  clearPatientSMSUnreachable,
  getPatientsSharingSMSPhone,
  inviteUserToMyOrg,
  inviteUserNoOrg,
}
